import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';
import { isPublicPageRoute } from '@/core/utils/is-public-page-route';

Sentry.init({
  dsn: process.env.SENTRY_DSN,
  integrations: [
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  ignoreErrors: ['Non-Error exception captured', 'Non-Error promise rejection captured'],
  tracesSampleRate: 1.0,
  sendDefaultPii: false,
  enabled: (process.env.NODE_ENV === 'staging' || process.env.NODE_ENV === 'production') && !isPublicPageRoute(),
});
